define('models/member/group',[
    'underscore', 'backbone', 'utils', 'mustache',
    // services
    'services/api',
    // parent
    'src/file-upload-model',
    // collections
    'collections/member/profiles'
], function(
    _, Backbone, U, Mustache,
    // services
    API,
    // parent
    FileUploadModel,
    // collections
    CProfiles
) {

    var MGroup = FileUploadModel.extend({
        idAttribute: '_id',
        blacklist: ['_menuActive', 'loginBackgroundImage', 'logo', 'filename'],
        files: ['loginBackgroundImage', 'logo'],
        urlRoot: function() {

            if (this.isNew()) {
                return API.url(Mustache.render('groups/{{{groupId}}}/add/', {
                    groupId: this.get("parent")
                }));
            } else {
                return API.url("groups");
            }
        },

        computeds: {
            logoUrl: {
                deps: ['logo'],
                get: function(logo) {
                    return logo && logo.type !== "text" ? logo.data : "assets/images/placeholer-image-300x100.jpg";
                },
            },
            logoData: {
                deps: ['logo'],
                get: function(logo) {
                    return logo ? logo.data : "assets/images/logo.png";
                },
                set: function(value) {
                    var logo = this.get('logo') || {};
                    return {
                        logo: MGroup.getLogoObject(logo.type, value)
                    };
                }
            },
            logoType: {
                deps: ['logo'],
                get: function(logo) {
                    // when a temporary image is set, the logo object is containing the blob info
                    if (logo instanceof Blob) {
                        return "image";
                    }

                    return logo ? logo.type : "image";
                },
                set: function(value) {
                    var logo = this.get('logo') || {};

                    if (logo instanceof Blob) {
                        return logo;
                    }

                    return {
                        logo: MGroup.getLogoObject(value, logo.data)
                    };
                }
            },

            brandColor: {
                deps: ['backgroundColor'],
                get: function(color) {
                    //if invalid color, default blue TC
                    if (!/^#[0-9A-F]{6}$/i.test(color)) {
                      color = '#00adef';
                    }
                    return color ? color : "#00adef";
                },
                set: function(value) {
                    return { backgroundColor: value };
                }
            },
            customButtonText: {
                deps: ['customButton'],
                get: function(button) {
                    var text = button ? button.text : "";
                    return text ? text : "Click here to visit my website";
                },
                set: function(value) {
                    var button = this.get('customButton') || {};
                    return {
                        customButton: MGroup.getCustomButtonObject(value, button.url, button.active)
                    };
                }
            },
            customButtonUrl: {
                deps: ['customButton'],
                get: function(button) {
                    var url = button ? button.url : "";
                    return url ? url : "https://example.com/";
                },
                set: function(value) {
                    var button = this.get('customButton') || {};
                    return {
                        customButton: MGroup.getCustomButtonObject(button.text, value, button.active)
                    };
                }
            },
            customButtonActive: {
                deps: ['customButton'],
                get: function(button) {
                    return button ? button.active : false;
                },
                set: function(value) {
                    var button = this.get('customButton') || {};
                    return {
                        customButton: MGroup.getCustomButtonObject(button.text, button.url, value)
                    };
                }
            }
        },

        initialize: function(model, opt) {
            this._resetProfiles();
            this.profiles.setGroup(this.getFlatAttributes());
        },

        parse: function(data, opt) {
            this._resetProfiles(_.omit(data, 'subgroups'));

            if (_.has(data, 'backgroundColor') && _.isString(data.backgroundColor)) {
                data.backgroundColor = data.backgroundColor.slice(0, 7);
            }
            return data;
        },

        _resetProfiles: function(group) {
            if (!this.profiles) {
                this.profiles = new CProfiles();
            }
            this.profiles.setGroup(group);
        },

        /**
         * @return a copy of the attributes hash without the nested subgroups.
         */
        getFlatAttributes: function() {
            return _.omit(this.attributes, 'subgroups');
        },

        getLogo: function() {
            return {
                data: this.get('logoData'),
                type: this.get('logoType'),
            };
        },

        isLogoImage: function() {
            return this.get('logoType') === "image";
        },

        isLogoText: function() {
            return this.get('logoType') === "text";
        },

        isOwner: function() {
            return this.get('isOwner');
        },

        setLogoFile: function(blob) {
            this.set('logo', blob);
        },

        setBackgroundFile: function(blob) {
            this.set('loginBackgroundImage', blob);
        },

        setLogoData: function(text) {
            this.set('logoData', text);
        },

        setLogoType: function(type) {
            this.set('logoType', type);
        },

        isExpired: function() {
            return this.get('isExpired');
        },

        isSupervisor: function() {
            return this.get('isSupervisor');
        },

        isTopLevelFirstGroup: function() {
            return this.get("parent") === null;
        },

        save: function(attrs, options) {
            // need to add blacklist option if logoType = text
            if (_.isString(this.get('logo'))) {
                options = _.extend({}, options, { blacklist: false });
            }

            MGroup.__super__.save.call(this, attrs, options);
        },

    }, {
        getCustomButtonObject: function(text, url, active) {
            return {
                text: _.isUndefined(text) ? null : text,
                url: _.isUndefined(url) ? null : url,
                active: _.isUndefined(active) ? null : active,
            };
        },
        getLogoObject: function(type, data) {
            return {
                type: _.isUndefined(type) ? null : type,
                data: _.isUndefined(data) ? null : data
            };
        },

    });

    // Return the model for the module
    return MGroup;
});

